import React from 'react';
import classNames from 'classnames';
import { StylishNewButton as Button } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

export type MapToolPaletteProps = {
  onDrawPoint: () => void;
  onDrawPolygon: () => void;
  onClear: () => void;
  onImportFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

export const MapToolPalette: React.FC<MapToolPaletteProps> = ({
  onDrawPoint,
  onDrawPolygon,
  onClear,
  onImportFileChange,
  className,
}) => {
  return (
    <div
      className={classNames(
        'map-tool-palette position-absolute d-flex flex-column gap-2',
        className
      )}
    >
      <Button
        customButton
        type="button"
        onClick={onDrawPoint}
        aria-label="Draw point"
        title="Draw point"
        className="map-tool-palette__button"
      >
        <SharedIcon iconName="location_pin" size="sm" />
      </Button>
      <Button
        customButton
        type="button"
        onClick={onDrawPolygon}
        aria-label="Draw polygon"
        title="Draw polygon"
        className="map-tool-palette__button"
      >
        <SharedIcon iconName="polyline" size="sm" />
      </Button>
      <Button
        customButton
        type="button"
        onClick={onClear}
        aria-label="Clear geometry"
        title="Clear geometry"
        className="map-tool-palette__button"
      >
        <SharedIcon iconName="delete" size="sm" />
      </Button>
      <Button
        customButton
        type="button"
        onClick={() => {
          const input = document.getElementById('file-import-import-geojson');
          if (input) {
            input.click();
          }
        }}
        aria-label="Import GeoJSON"
        title="Import GeoJSON"
        className="map-tool-palette__button"
      >
        <SharedIcon iconName="file_json" size="sm" />
      </Button>
      <input
        id="file-import-import-geojson"
        type="file"
        accept=".geojson,.json,application/geo+json,application/json"
        onChange={onImportFileChange}
        style={{ display: 'none' }}
        data-testid="file-import-input-import"
      />
    </div>
  );
};
